'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _AlertTypes = require('../alert/AlertTypes');

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UIAlert = _react2.default.createClass({
  displayName: 'UIAlert',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    closeable: _react.PropTypes.bool.isRequired,
    onClose: _react.PropTypes.func,
    titleText: _react.PropTypes.node,
    type: _react.PropTypes.oneOf(Object.keys(_AlertTypes.ALERT_TYPES)).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_AlertTypes.ALERT_USES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      closeable: false,
      type: 'info',
      use: 'default'
    };
  },
  handleCloseButtonClick: function handleCloseButtonClick(evt) {
    var onClose = this.props.onClose;

    (0, _Functions.callIfPossible)(onClose, evt);
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        closeable = _props.closeable,
        __onClose = _props.onClose,
        titleText = _props.titleText,
        type = _props.type,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'closeable', 'onClose', 'titleText', 'type', 'use']);

    var computedClassName = (0, _reactUtils.classNames)('alert', 'private-alert', 'private-alert--page-wide', _AlertTypes.ALERT_TYPES[type], className, {
      'private-alert--dismissable alert-dismissable': closeable
    }, {
      'private-alert--inline': use === 'inline'
    });

    return _react2.default.createElement(
      'div',
      _extends({}, rest, {
        'aria-atomic': 'true',
        'aria-live': 'assertive',
        className: computedClassName,
        role: 'alert'
      }),
      _react2.default.createElement(
        'div',
        { className: 'private-alert__inner' },
        titleText ? _react2.default.createElement(
          'h2',
          { className: 'private-heading-5 private-alert__title' },
          titleText
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'private-alert__body has--vertical-spacing' },
          children
        )
      ),
      closeable ? _react2.default.createElement(_UICloseButton2.default, {
        className: 'close private-alert__close',
        onClick: this.handleCloseButtonClick,
        size: 'medium'
      }) : null
    );
  }
});

exports.default = UIAlert;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/alert/UIAlert.js
// module id = 163
// module chunks = 0